module.exports = __webpack_public_path__ + "img/seul.f76dac84.jpg";